import { Component, EventEmitter, Input, Output, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.css'],
  standalone: false
})
export class CustomDatepickerComponent {
  @Input() label = '';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  open = false;
  viewDate: Date;
  days: (number | null)[] = [];
  monthLabel = '';

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocClick(e: Event) {
    if (!this.el.nativeElement.contains(e.target)) this.open = false;
  }

  toggle() {
    this.open = !this.open;
    if (this.open) {
      this.viewDate = this.value ? new Date(this.value + 'T00:00:00') : new Date();
      this.buildCalendar();
    }
  }

  buildCalendar() {
    const y = this.viewDate.getFullYear();
    const m = this.viewDate.getMonth();
    this.monthLabel = this.viewDate.toLocaleString('default', { month: 'long', year: 'numeric' });
    const firstDay = new Date(y, m, 1).getDay();
    const daysInMonth = new Date(y, m + 1, 0).getDate();
    this.days = [];
    for (let i = 0; i < firstDay; i++) this.days.push(null);
    for (let d = 1; d <= daysInMonth; d++) this.days.push(d);
  }

  prevMonth() {
    this.viewDate.setMonth(this.viewDate.getMonth() - 1);
    this.buildCalendar();
  }

  nextMonth() {
    this.viewDate.setMonth(this.viewDate.getMonth() + 1);
    this.buildCalendar();
  }

  selectDay(day: number) {
    const y = this.viewDate.getFullYear();
    const m = String(this.viewDate.getMonth() + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    this.value = `${y}-${m}-${d}`;
    this.valueChange.emit(this.value);
    this.open = false;
  }

  today() {
    const now = new Date();
    this.selectDay(now.getDate());
    this.viewDate = now;
    this.buildCalendar();
  }

  clear() {
    this.value = '';
    this.valueChange.emit(this.value);
    this.open = false;
  }

  isSelected(day: number): boolean {
    if (!this.value || !day) return false;
    const y = this.viewDate.getFullYear();
    const m = String(this.viewDate.getMonth() + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return this.value === `${y}-${m}-${d}`;
  }
}
